import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import { InterviewKind } from '@Domain/Enums/Interviews/InterviewKind';
import type PlainDate from '@Domain/PlainDate';

/**
 * Body of the create call for an entered text: the server turns `text` into a transcript, so no
 * recording, consent or participant is sent. `facilityId`/`subject` are route identifiers and
 * never enter the body. `text` is sent as typed: the server splits it into paragraphs.
 */
class CreateTextInterview {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly clientReference: string,
		public readonly name: string,
		public readonly conductedOn: PlainDate,
		public readonly text: string,
		public readonly preparationId: number,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			clientReference: this.clientReference,
			name: this.name,
			kind: InterviewKind.TEXT,
			conductedOn: this.conductedOn.toApi(),
			text: this.text,
			preparation: this.preparationId,
		};
	}
}

export default CreateTextInterview;
